/* eslint-disable max-len */

const placeOffers = (applications: IApplication[], phase: number): (IApplication[] | IApplication | boolean | undefined)[] => {
  const offered = applications?.filter((a) => a.response.offered);
  const accepted = offered.filter((a) => a.response.offerAccepted).length === 1;
  const rejected = offered.filter((a) => a.response.offerAccepted === false).length === 1;
  const areAllNotOffered = applications.filter((a) => !a.response.cancelled && a.response.offered === false).length === applications.filter((a) => !a.response.cancelled).length && offered.length === 0;
  const offeredNotRejected = offered.filter((a) => a.response.offerAccepted !== false);
  const acceptable = offeredNotRejected.filter((a) => !a.response.standby);
  const offeredStandby = offeredNotRejected.find((a) => a.response.standby);
  let placeOfferShowing = !(applications.length === 0 || phase < 3);
  if (placeOfferShowing) {
    placeOfferShowing = areAllNotOffered || (applications || []).filter((a) => a.response.offered && a.response.offerAccepted == null).length > 0 || applications.filter((a) => a.response.offerAccepted).length > 1;
  }
  // I det tilfælde, at vi har accepteret en ledig plads, men også har en standby-plads - så skal banneret IKKE vises!
  if (placeOfferShowing) {
    placeOfferShowing = !(offeredNotRejected.filter((a) => a.response.standby).length > 0 && accepted);
  }
  return [placeOfferShowing, offered, accepted, rejected, areAllNotOffered, offeredNotRejected, acceptable, offeredStandby];
};

export default placeOffers;
